import React from 'react';
import { Mail } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export function Footer() {
  const { language, t } = useLanguage();

  return (
    <footer className="relative bg-slate-950 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Column 1 - Brand */}
          <div className="lg:col-span-1">
            <a href={`/${language}/`} className="font-heading font-bold text-2xl text-white mb-4 block">
              DATHENT
            </a>
            <div className="space-y-2">
              <p className="text-sm font-semibold text-slate-300">
                DATHENT SAX S.L.
              </p>
              <p className="text-xs text-slate-500">
                NIF B22632632 · VAT: ESB22632632
              </p>
              <p className="text-xs text-slate-400 leading-relaxed mt-3">
                Avenida Reyes Católicos 9, Bajo<br />
                03630 Sax (Alicante), Spain
              </p>
              <div className="space-y-1.5 pt-3">
                <a 
                  href="mailto:info@dathent.com" 
                  className="flex items-center gap-2 text-xs text-primary hover:text-purple-400 transition-colors"
                >
                  <Mail size={14} />
                  info@dathent.com
                </a>
                <p className="text-xs text-slate-400">
                  Phone: +34 865 443 750
                </p>
              </div>
              <p className="text-xs text-slate-500 italic pt-3">
                {t('footer.brand.registry')}
              </p>
            </div>
          </div>

          {/* Column 2 - Product */}
          <div>
            <h4 className="font-semibold text-white mb-4">
              {t('footer.product.title')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#solutions" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.product.websiteDev')}
                </a>
              </li>
              <li>
                <a href="#team" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.product.support')}
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.product.fullDev')}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.product.enterprise')}
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3 - Company */}
          <div>
            <h4 className="font-semibold text-white mb-4">
              {t('footer.company.title')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#about" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.company.about')}
                </a>
              </li>
              <li>
                <a href="#process" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.company.process')}
                </a>
              </li>
              <li>
                <a href="#pricing" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.company.pricing')}
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.company.contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4 - Legal */}
          <div>
            <h4 className="font-semibold text-white mb-4">
              {t('footer.legal.title')}
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href={`/${language}/terms`} className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.legal.terms')}
                </a>
              </li>
              <li>
                <a href={`/${language}/subscription`} className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.legal.subscription')}
                </a>
              </li>
              <li>
                <a href={`/${language}/refund`} className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.legal.refund')}
                </a>
              </li>
              <li>
                <a href={`/${language}/privacy`} className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.legal.privacy')}
                </a>
              </li>
              <li>
                <a href={`/${language}/cookies`} className="text-sm text-slate-400 hover:text-white transition-colors">
                  {t('footer.legal.cookies')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Line */}
        <div className="pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-slate-500">
            <p>
              © 2025 DATHENT SAX S.L. {t('footer.bottom.rights')}
            </p>
            <p className="text-slate-600">
              {t('footer.bottom.tagline')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
